import { DirectDeliveryCasePage } from "./pages/DirectDeliveryCasePage";
import { ProposalIntroPage } from "./pages/ProposalIntroPage";
import { ShopPage } from "./pages/ShopPage";
import { resolveRoute } from "./routes";

function App() {
  const route = resolveRoute(window.location.pathname);

  if (route === "case") {
    return <DirectDeliveryCasePage />;
  }

  if (route === "proposal") {
    return <ProposalIntroPage />;
  }

  if (route === "not-found") {
    return (
      <main className="not-found-page">
        <p>Sub Zero Treats</p>
        <h1>That treat escaped.</h1>
        <a href="/">Return home</a>
      </main>
    );
  }

  return <ShopPage />;
}

export default App;
